import React from 'react';
import Alert from '@mui/material/Alert';

export const applicationEnvironment = process.env.REACT_APP_ENVIRONMENT || 'development';

export default function EnvironmentBanner() {
  if (applicationEnvironment !== 'staging') return null;
  return <Alert data-testid="staging-environment-banner" severity="info" square icon={false} sx={{ fontWeight: 900, justifyContent: 'center' }}>STAGING — test data only</Alert>;
}
